import { render, staticRenderFns } from "./storeProfit.vue?vue&type=template&id=a018f11a&scoped=true"
import script from "./storeProfit.vue?vue&type=script&lang=js"
export * from "./storeProfit.vue?vue&type=script&lang=js"
import style0 from "./storeProfit.vue?vue&type=style&index=0&id=a018f11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a018f11a",
  null
  
)

export default component.exports